import { useState } from "react";
import { ERROR_500, INVALID, INVALID_CUIT } from "../data/data";

const useStep = (callback, changeStep, setDataToNextStep, recoveryByCuit) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const onFinishStep = (values) => {
        setError(null);
        setLoading(true);
        callback(values)
            .then((res) => {
                const resul = res.data;
                // const resul = res.data;           
				
				// Cuando se llama al forgotpassowordByCuit, se devuelve el mail al cual se debe enviar el codigo de recuperacion
				const mailLinkedWithCuit = resul?.message;
				
                const { resul: okStep } = resul;
                console.log({ okStep });
                if (okStep) {
					// Si el mail esta definido, es porque se llamó al forgotpassowordByCuit
					mailLinkedWithCuit && setDataToNextStep(mailLinkedWithCuit);
                    changeStep();
                } else {
					recoveryByCuit ? setError(INVALID_CUIT) : setError(INVALID);
                }
                setLoading(false);
            })
            .catch((error) => {
				console.log({error});
                setLoading(false);
                setError(ERROR_500);
            });
    };

    return {
        loading,
        error,
        onFinishStep,
    };
};

export default useStep;
